// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `table {
    width: 100%;
  }
  
  th, td {
    padding: 10px !important;
  }
  
  mat-form-field {
    width: 40%;
  }
  
  .text-right {
    text-align: right !important;
  }
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIndlbGZ5LXRhYmxlLmNvbXBvbmVudC5jc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUE7SUFDSSxXQUFXO0VBQ2I7O0VBRUE7SUFDRSx3QkFBd0I7RUFDMUI7O0VBRUE7SUFDRSxVQUFVO0VBQ1o7O0VBRUE7SUFDRSw0QkFBNEI7RUFDOUIiLCJmaWxlIjoid2VsZnktdGFibGUuY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbInRhYmxlIHtcbiAgICB3aWR0aDogMTAwJTtcbiAgfVxuICBcbiAgdGgsIHRkIHtcbiAgICBwYWRkaW5nOiAxMHB4ICFpbXBvcnRhbnQ7XG4gIH1cbiAgXG4gIG1hdC1mb3JtLWZpZWxkIHtcbiAgICB3aWR0aDogNDAlO1xuICB9XG4gIFxuICAudGV4dC1yaWdodCB7XG4gICAgdGV4dC1hbGlnbjogcmlnaHQgIWltcG9ydGFudDtcbiAgfSJdfQ== */`, "",{"version":3,"sources":["webpack://./src/app/core/components/welfy-table/welfy-table.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,4BAA4B;EAC9B;AACF,4lBAA4lB","sourcesContent":["table {\n    width: 100%;\n  }\n  \n  th, td {\n    padding: 10px !important;\n  }\n  \n  mat-form-field {\n    width: 40%;\n  }\n  \n  .text-right {\n    text-align: right !important;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
